export default "__VITE_ASSET__D7lFCVH1__"